import board from 'assets/image/board.png'
import { Link } from 'react-router-dom'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import css from './style.module.scss'

export const UpgradeSubscriptionTeam = () => (
	<article className={css.root}>
		<h2 className={`${css.title} ${typo.subtitle}`}>
			Upgrade your subscription to TEAM plan
		</h2>

		<p className={`${css.lead} ${typo.largeButton}`}>
			Move your subscription up!
		</p>
		<img alt='snail' className={css.image} src={board} width={190} />
		<Button
			as={Link}
			className={css.link}
			to='/upgrade'
			typography={typo.largeButton}
		>
			Upgrade now
		</Button>
	</article>
)
